export default "__VITE_ASSET__f715f03e__"